export default __webpack_public_path__ + "locales/bg/DeleteProfileEverDialog.json?hash=ceeaddd0b6ec9066a11bb47cac75cf6a";